import styled, { css } from "styled-components";
import type { IconName, IconSize } from "../icons";
import type { ButtonProps as AntButtonProps } from "antd/es/button";
import type { ButtonVariant, ButtonSize, ButtonType } from "./Button";
import Button from "./Button";

interface IconButtonProps extends AntButtonProps {
  iconName: IconName;
  iconSize?: IconSize;
  noHover?: boolean;
  buttonType?: ButtonType;
  buttonVariant?: ButtonVariant;
  buttonSize?: ButtonSize;
  dataCy?: string;
}

const IconButton = ({
  iconName,
  noHover = false,
  buttonSize = "default",
  buttonType = "primary",
  buttonVariant = "basic",
  ...rest
}: IconButtonProps) => {
  return (
    <StyledButton
      $buttonSize={buttonSize}
      buttonType={buttonType}
      buttonVariant={buttonVariant}
      iconNameLeft={iconName}
      noIconHover={noHover}
      {...rest}
    />
  );
};

const sizeStyles = {
  default: css`
    height: 32px !important;
    width: 32px !important;

    svg {
      height: 18px !important;
      width: auto;
    }
  `,

  large: css`
    height: 40px !important;
    width: 40px !important;

    svg {
      height: 18px !important;
      width: auto;
    }
  `,

  small: css`
    height: 28px !important;
    width: 28px !important;

    svg {
      height: 16px !important;
      width: auto;
    }
  `,

  tiny: css`
    height: 20px !important;
    width: 20px !important;

    svg {
      height: 16px !important;
      width: 16px !important;
    }
  `,
};

const StyledButton = styled(Button)<{ $buttonSize: ButtonSize }>`
  display: grid;
  place-items: center;
  padding: 0 !important;
  margin: 0 !important;

  ${({ $buttonSize }) => sizeStyles[$buttonSize]}
`;

export default IconButton;
